import { render, staticRenderFns } from "./ImportInspectionWithAI.vue?vue&type=template&id=1c08bdd2&scoped=true&"
import script from "./ImportInspectionWithAI.vue?vue&type=script&lang=js&"
export * from "./ImportInspectionWithAI.vue?vue&type=script&lang=js&"
import style0 from "./ImportInspectionWithAI.vue?vue&type=style&index=0&id=1c08bdd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08bdd2",
  null
  
)

export default component.exports